import React, { useEffect, useState } from 'react';
import TextBox from 'devextreme-react/ui/text-box';
import ButtonComponent from 'components/ButtonComponent/ButtonComponent';
import notify from 'devextreme/ui/notify';
import usePushNotifications from 'hooks/usePushNotifications';

const TestPushNotificationComponent = () => {
    const { sendLocalNotification } = usePushNotifications();
    const [message, setMessage] = useState('This is a local test notification.');
    const [url, setUrl] = useState('/home');

    useEffect(() => {
        if ('Notification' in window) {
            if (Notification.permission === 'denied') {
                notify({
                    message: 'Push notifications are blocked. Please enable them in your browser settings.',
                    type: 'warning',
                    displayTime: 1000,
                    width: 420,
                    position: {
                        my: 'top center',
                        at: 'top center',
                        of: window,
                    },
                });
            }else{
                notify({
                    message: 'Push notifications are enabled!',
                    type: 'success',
                    displayTime: 1000,
                    width: 420,
                    position: {
                        my: 'top center',
                        at: 'top center',
                        of: window,
                    },
                });
            }
        }

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then((reg) => {
                console.log('Registration:', reg);
                console.log('Active worker:', reg.active);
            });
        }
    }, []);

    const handleSend = async () => {
        try {
            await sendLocalNotification('Test Notification', message, url || undefined);
            console.log('Notification sent');
        } catch (error) {
            console.error('Failed to send notification', error);

            // Optional: show a fallback toast if permission is the problem
            if (Notification.permission !== 'granted') {
                notify({
                    message: 'Unable to send notification. Push permissions are not granted.',
                    type: 'error',
                    displayTime: 5000,
                });
            }
        }
    };

    return (
        <React.Fragment>
            <h2 className="content-block">Test Push Notifications</h2>
            <div className="content-block">
                <div className="dx-card responsive-paddings">
                    <div className="form-group">
                        <TextBox
                            value={message}
                            placeholder="Notification message"
                            onValueChanged={(e) => setMessage(e.value ?? '')}
                            showClearButton={true}
                        />
                    </div>
                    <div className="form-group">
                        <TextBox
                            value={url}
                            placeholder="Landing page (e.g. /home)"
                            onValueChanged={(e) => setUrl(e.value ?? '')}
                            showClearButton={true}
                        />
                    </div>
                    <ButtonComponent
                        text="SEND NOTIFICATION"
                        handleClick={handleSend}
                        stylingMode="contained"
                        type="default"
                        width={250}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default TestPushNotificationComponent;
